import Head from "next/head";

import { useRouter, NextRouter } from "next/router";

import { useTranslator } from "@eo-locale/react";

import { Text, Heading } from "@/storybook-components";
import Form from "./form";
import { useAppSelector } from "@/redux/store/hooks";

const App = (): JSX.Element => {
  const { translate } = useTranslator();
  const router: NextRouter = useRouter();
  const { name } = useAppSelector((state) => state.site.site);
  const resetPasswordToken = router.query?.token;
  return (
    <>
      <Head>
        <title>{`${translate("users.forgotPassword")} | ${name}`}</title>
      </Head>
      <Heading as="h1" my={3}>
        {resetPasswordToken === "invalid"
          ? translate("users.resetPasswordLinkExpired")
          : translate("users.resetPassowrd")}
      </Heading>
      <Text my={3}>
        {resetPasswordToken === "invalid"
          ? translate("users.expiredTokenDescription")
          : translate("users.description")}
      </Text>
      <Form />
    </>
  );
};

export default App;
